import React from 'react';

import { ChevronLeft, ChevronRight } from '@xsolla/ui-icons';

import { ArrowButton, PaginationArrowButtonDiv } from './style';

interface Props {
  setPage: (page: number) => void;
  page: number;
  userCount: number | undefined;
}

export const PaginationArrowButton = ({ setPage, userCount, page }: Props): JSX.Element => {
  return (
    <PaginationArrowButtonDiv>
      <ArrowButton
        direction="left"
        onClick={() => setPage(page - 1)}
        disabled={!userCount || page === 1}>
        <ChevronLeft />
      </ArrowButton>
      <ArrowButton
        direction="right"
        onClick={() => setPage(page + 1)}
        disabled={!userCount || (userCount && userCount < 20) || false}>
        <ChevronRight />
      </ArrowButton>
    </PaginationArrowButtonDiv>
  );
};
